import { mapPaymentScheduleStatusEnumToText, OperatorPayment, PaymentScheduleStatus } from "../model";
import { ColumnDef } from "@tanstack/react-table";

export const operatorsColumns: ColumnDef<OperatorPayment>[] = [
  {
    header: "Due for Operator",
    accessorFn: (r) => r?.amount,
  },
  {
    header: "Paid so far",
    accessorFn: (r) => r?.paidSoFar,
  },
  {
    header: "Currency",
    accessorFn: (r) => (r?.booking?.yacht?.operator?.transferDetails?.currencyCode || "EUR"),
  },
  {
    header: "Due date",
    accessorFn: (r) => <p className="whitespace-nowrap">{r?.dueDate}</p>,
    cell: ({ getValue }) => getValue(),
  },
  {
    header: "Payment status",
    accessorFn: (r) => {
      let bgColor = "";
      let textColor = "";

      switch (r.status) {
        case PaymentScheduleStatus.OVERDUE:
          bgColor = "bg-red-400";
          textColor = "text-secondary-foreground";
          break;
        case PaymentScheduleStatus.FULLY_PAID:
          bgColor = "bg-green-300";
          textColor = "text-secondary-foreground";
          break;
        case PaymentScheduleStatus.PARTIALLY_PAID:
          bgColor = "bg-green-500";
          textColor = "text-secondary-foreground";
          break;
        case PaymentScheduleStatus.WAITING:
          bgColor = "bg-yellow-400";
          textColor = "text-secondary-foreground";
          break;
        default:
          bgColor = "bg-gray-200";
          textColor = "text-gray-600";
      }

      return (
        <span className={`inline-block rounded-full ${bgColor} ${textColor} px-3 py-1 text-nowrap`}>
          {mapPaymentScheduleStatusEnumToText(r.status)}
        </span>
      );
    },
    cell: ({ getValue }) => getValue(),
  },
  {
    header: "Supplier",
    accessorFn: (r) => (r?.booking?.yacht?.operator?.name ? r.booking?.yacht?.operator?.name : "-"),
  },
  {
    header: "Bank transfer details",
    accessorFn: (r) => (
      <>
        <p className="whitespace-nowrap">{r?.booking?.yacht?.operator?.transferDetails?.recipientName}</p>
        <p className="whitespace-nowrap">{r?.booking?.yacht?.operator?.transferDetails?.accountNumber}</p>
      </>
    ),
    cell: ({ getValue }) => getValue(),
  },
  {
    header: "Start date",
    accessorFn: (r) => <p className="whitespace-nowrap">{r?.booking?.bookingDateFrom}</p>,
    cell: ({ getValue }) => getValue(),
  },
  {
    header: "Yacht booked",
    accessorFn: (r) => (r?.booking?.yacht?.name ? r?.booking?.yacht?.name : "-"),
  },
];
